import Collection from './generic/collection'
import { getCfg } from './utils/getCfg'

export const instance = '[data-js-associated-control]'

export class AssociatedControl {
  els = {
    instance
  }

  defaultCfg = {
    selector: '#associated-input'
  }

  constructor (instance) {
    this.instance = instance
    this.cfg = getCfg(this.instance, this.els.instance, this.defaultCfg)
    this.associatedControl = document.querySelector(this.cfg.selector)
    if (!this.associatedControl) {
      console.debug('Associated control is not found!')
      return
    }
    this.init()
    this.bindEvents()
  }

  manageControl() {
    const isChecked = this.instance.checked
    if (isChecked) {
      this.associatedControl.disabled = false
    } else {
      this.associatedControl.checked = false
      this.associatedControl.disabled = true
    }
  }

  handleChange() {
    this.manageControl()
  }

  init() {
    this.manageControl()
  }

  bindEvents() {
    this.instance.addEventListener('change', () => this.handleChange())
  }
}

export class AssociatedControlCollection extends Collection {
  constructor () {
    super(instance, AssociatedControl)
    this.init()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new AssociatedControl(el)
    })
  }
}